<template>
  <div class="events">
    <main>
      <section class="events-intro">
          <h1>Edit Events</h1>
          <button @click="showForm">+ Add New Event</button>
      </section>

      <section class="add-event" v-show="addNew === true">
        <h3>Add an Event</h3>
        <div>
          <label for="startdate">Event Start Date (for filtering)</label><br>
          <input v-model="startdate" type="date" id="startdate" name="startdate">
        </div>
        <div>
          <label for="enddate">Event End Date (for filtering)</label><br>
          <input v-model="enddate" type="date" id="enddate" name="enddate">
        </div>
        <div>
          <label for="date">Event Date Range (for display)</label><br>
          <input v-model="date" type="text" id="date" name="date">
        </div>
        <div>
          <label for="event">Event Name</label><br>
          <input v-model="event" type="text" id="event" name="event">
        </div>
        <div>
          <label for="studio">Studio or Business Name</label><br>
          <input v-model="studio" type="text" id="studio" name="studio">
        </div>
        <div>
          <label for="location">Location (City, State/Province)</label><br>
          <input v-model="location" type="text" id="location" name="location">
        </div>
        <div>
          <label for="country">Country (for filtering)</label><br>
          <select v-model="country" name="country" id="country">
            <option disabled value="">Please select one</option>
            <option v-for="(country, index) in countries" :key="index" :value="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
        <div>
          <label for="email">Email (not for display)</label><br>
          <input v-model="email" type="email" id="email" name="email">
        </div>
        <div>
          <label for="url">Website URL (for details &amp; registration)</label><br>
          <input v-model="url" type="text" id="url" name="url">
        </div>
        <div class="jg">
          Joe's Gym?
          <input type="radio" id="jg1" value="true" name="jg" v-model="joes_gym">
          <label for="jg1">Yes</label>
          <input type="radio" id="jg2" value="false" name="jg" v-model="joes_gym">
          <label for="jg2">No</label>
        </div>
        <input v-model="published" type="hidden" id="published" name="published">
        <button @click="addEvent">Submit</button> <button @click="hideForm">Cancel</button>
        <div>
          <p v-if="error">A problem occurred and your event information couldn't be submitted.<br>Please try again later.</p>
          <p v-if="message">Your event information was submitted successfully.</p>
        </div>
      </section>

      <div
        v-if="message"
        class="alert"
        :class="{ error: error }"
        @click="closeMessage"
      >
        <p>{{ message }}</p>
      </div>

      <section class="events-results">
        <div class="loading" v-if="loading">
          <img src="https://s3.amazonaws.com/s3.pilates.com/img/contrology-loader.gif" alt="Stay tuned"/>
        </div>
        <div class="events-list">
          <event-card
            @delete-event="deleteEvent"
            @update-event="updateEvent"
            v-for="event in displayedEvents"
            :key="event._id"
            :event="event"
            :countries="countries"
            :is-editing="false"
            class="event"
          />
        </div>
      </section>

    </main>
  </div>
</template>s

<script>
import ApiService from '@/js/ApiService.js';
import EventCard from '@/components/EventCard.vue';

export default {
  name: 'editevents',

  metaInfo: {
    title: "Edit",
    titleTemplate: "%s | Contrology | Balanced Body",
    meta: [
      {
        name: "robots",
        content: "noindex, nofollow"
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
      }
    ]
  },

  components: {
    EventCard
  },

  data() {
    return {
      error: false,
      loading: false,
      message: null,
      displayedEvents: [],
      addNew: false,
      startdate: '',
      enddate: '',
      date: '',
      event: '',
      studio: '',
      location: '',
      country: '',
      email: '',
      url: '',
      published: true,
      joes_gym: false,
      countries: []
    }
  },

  created() {
    this.fetchEvents();
    this.fetchCountryList();
  },

  methods: {
    fetchEvents() {
      this.error = false;
      this.loading = true;
      ApiService.getAllEvents()
      .then(response => {
        this.loading = false;
        this.events = response.data;
        this.displayedEvents = this.events;
      })
      .catch(error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.error(error);
      })
    },

    fetchCountryList() {
      this.error = false;
      this.loading = true;
      ApiService.getCountryList()
      .then(response => {
        this.loading = false;
        this.countries = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.error(error);
      })
    },

    addEvent() {
      this.error = false;
      this.loading = true;
      ApiService.addEvent({
        startdate: this.startdate,
        enddate: this.enddate,
        date: this.date,
        event: this.event,
        studio: this.studio,
        location: this.location,
        country: this.country,
        email: this.email,
        url: this.url,
        published: this.published,
        joes_gym: this.joes_gym
      })
      .then( () => {
        this.loading = false;
        this.message = "The event has been added. Please note the database might take a few minutes to reflect his change.";
      })
      .catch( error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.log(error);
      })
      .then( () => {
        this.fetchEvents();
        this.addNew = false;
        this.startdate = '';
        this.enddate = '';
        this.date = '';
        this.event = '';
        this.studio = '';
        this.location = '';
        this.country = '';
        this.email = '';
        this.url = '';
      })
    },

    deleteEvent(event) {
      this.error = false;
      this.loading = true;
      let resp = confirm("You're about to delete an event. Do you want to continue?");
      if ( resp === true) {
        ApiService.deleteEvent(event._id)
        .then( () => {
          this.loading = false;
          this.message = "The event has been deleted. Please note the database might take a few minutes to reflect his change.";
        })
        .catch( error => {
          this.loading = false;
          this.error = true;
          this.message = error;
          console.error(error);
        })
        .then( () => {
          this.fetchEvents();
        })
      } else {
        this.loading = false;
      }
    },

    updateEvent(event) {
      this.error = false;
      this.loading = true;
      ApiService.updateEvent(event._id, {
        startdate: event.startdate,
        enddate: event.enddate,
        date: event.date,
        event: event.event,
        studio: event.studio,
        location: event.location,
        country: event.country,
        email: event.email,
        url: event.url,
        published: event.published,
        joes_gym: event.joes_gym
      })
      .then( () => {
        this.loading = false;
        this.message = "The event has been updated. Please note the database might take a few minutes to reflect his change.";
      })
      .then( () => {
        this.fetchEvents();
      })
      .catch( error => {
        this.loading = false;
        this.error = true;
        this.errorMessage = error;
        console.error(error);
      })
    },

    closeMessage() {
      this.error = false;
      this.message = '';
    },

    showForm() {
      this.addNew = true;
    },

    hideForm() {
      this.addNew = false;
    },
  }
}
</script>

<style lang="scss" scoped>
main {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.loading {
  position: absolute;
  top: 30%;
  left: 50%;
}

.add-event {
  width: 100%;
  margin: 30px 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.add-event > div {
  width: 100%;
  max-width: 400px;
}

.events-results {
  margin-top: 20px;
}

.events-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.alert {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  margin: 0 auto;
  background-color: green;
  color: var(--white);
  padding: 5px 20px;
  border-radius: 0 0 5px 5px;
  font-size: 1.1rem;
}

.alert::after {
  content: "✕";
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px 15px;
}

.error {
  background-color: red;
}

button {
  width: 200px;
  height: 30px;
  font-size: 1em;
  margin-top: 10px;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  transition: .2s;
  cursor: pointer;
}

button:hover {
  background-color: #808080;
}

label, p {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: .875em;
  line-height: 1.614;
}

input,
select {
  border: 1px solid #5f6062;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  font-size: 1em;
}

input[type="date"] {
  font-family: var(--roboto);
  font-size: 1em;
}

.jg {
  display: flex;
  align-items: center;
  width: auto !important;
}
</style>